import React, { useEffect, useState } from "react";
import { Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import back from "../../../assets/icons/back.svg";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import "../customer/customer.css";
import ApporveRejectModal from "../../../components/modals/approve-reject-modal";
import { onboardRequestDetail } from "../../../redux/actions/customerActions";
import { useDispatch } from "react-redux";
import DoctorRequestView from "../../../components/customer-vew/doctorRequestView";
import PharmacyRequestView from "../../../components/customer-vew/pharmacy-request-View";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import TableContainer from "../../../components/layout/table-container/table-container";
import ApproveRequestModal from "../../../components/modals/customer/approve-request-modal";

const RequestView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [rejectShow, setRejectShow] = useState(false);
  const [approveShow, setApproveShow] = useState(false);
  const [customerViewData, setCustomerViewData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approveRequest, setApproveRequest] = useState(false);

  console.log(customerTypeData?.user_type, "dshbjd");

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );
  console.log(state);

  useEffect(() => {
    console.log(state);
    dispatch(onboardRequestDetail(state, onSuccess, onError));
    setCustomerTypeData(state);
    setLoading(true);
  }, []);

  const onSuccess = (data) => {
    console.log(data);
    setLoading(false);
    setCustomerViewData(data.data.data);
    // setCustomerDoctordata(data.data.data.pharmacyDoctors);
    console.log(data.data.data.pharmacyDoctors.pharmacy_id);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  const Breadcrumb = ({ match }) => (
    <span>
      {match?.route?.path?.endsWith("view/:id") &&
        (customerViewData.code
          ? ` / ${customerViewData.code} - view`
          : " / view")}
    </span>
  );
  return (
    <MainLayout breadcrumbData={Breadcrumb}>
      <div className="search-container d-flex justify-content-between px-3">
        <div
          className="d-flex align-items-center p-2 m-1 mb-2 cursor_pointer"
          onClick={() => navigate(-1)}
        >
          <img src={back} alt="back_btn" />
          <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
            BACK
          </span>
        </div>
        <div className=" d-flex justify-content-between m-1 mb-2">
          <button className="px-4 mx-2 m-2 rounded-1 assign-btn fw_600 fs_14 py-2">
            Change Doctor Type
          </button>
          <button className="px-4 mx-2 m-2 rounded-1 assign-btn fw_600 fs_14 py-2">
            Change Pharmacy Type
          </button>

          <ApporveRejectModal
            title="Do you want to approve this user??"
            btnName="APPROVE"
            btnColor="#2AD3E7"
            show={approveShow}
            handleClose={() => setApproveShow(false)}
          />
          <ApporveRejectModal
            title="Do you want to reject this user?"
            btnName="REJECT"
            show={rejectShow}
            handleClose={() => setRejectShow(false)}
          />
        </div>
      </div>

      {loading == true ? (
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <LoadingSpinnerTable show={loading} />
        </div>
      ) : (
        <div className="scrolling">
          <div className="fn_Nunito">
            {customerTypeData?.user_type == "doctor" ? (
              <>
                <DoctorRequestView customerViewData={customerViewData} />
              </>
            ) : (
              <PharmacyRequestView customerViewData={customerViewData} />
            )}
          </div>
          <>
            <div className="basic-details-container  my-3 mt-5 mx-4 my-auto d-flex align-items-center">
              <label className="basic-title mx-2 mb-1">Approvals</label>
            </div>
            <div className="row my-4">
              <div className="customer-detail-table-container col-6 ms-5">
                <TableContainer>
                  <thead>
                    <tr className="table-rows ">
                      <th className="table-heads" width={"4%"}>
                        <span className="fw_600">#</span>
                      </th>
                      <th className="table-heads fw_700 " width={"6%"}>
                        <span className="fw_600">FFID </span>
                      </th>

                      <th className="table-heads " width={"10%"}>
                        <span className="fw_600"> Name </span>
                      </th>
                      <th className="table-heads " width={"10%"}>
                        <span className="fw_600"> Status</span>
                      </th>
                      <th className="table-heads " width={"8%"}>
                        <span className="fw_600"> Date & Time </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative" }}>
                    <tr>
                      <td
                        colSpan="1"
                        className="text-center no-data-container fs_16"
                      >
                        <span>~ No Data Found ~</span>
                      </td>
                    </tr>
                  </tbody>
                </TableContainer>
              </div>
              <div className="col-sm-6 col-xxl-3">
                <div className="mb-2 mx-0 px-3">
                  <h5 className="color_b0b3c7 text-nowrap fs_14 fw_500 m-0">
                    Approve Request
                  </h5>
                  <button
                    onClick={() => setApproveRequest(true)}
                    className="w-75 my-2 rounded-1 assign-btn fw_600 fs_14 py-2"
                  >
                    APPROVE
                  </button>
                </div>
              </div>
            </div>
          </>
        </div>
      )}
      <ApproveRequestModal
        show={approveRequest}
        handleClose={() => setApproveRequest(false)}
      />
    </MainLayout>
  );
};

export default RequestView;
